import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as localStorage from '../../../localStorage/localStorage';
import ReactPlayer from 'react-player';
import * as animationHelper from "../../../helpers/animationHelper"; //https://www.npmjs.com/package/react-player
const SHOW_CONTROLS = true;

class ReactVideoInline extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            userData: this.props.userData,
            screenObject: this.props.screenObject,
            video: this.props.video,
            locale: appHelper.getLocalData(this.props.screenObject),
            responseData: {
                latestResponse: {}
            },
            isPlaying: this.props.autoPlay,
            status: objectConstants.STATUS_NOT_STARTED,
            trackable: true,
            autoPlay: this.props.autoPlay,
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            play_label: appHelper.getLocaleString("play_label"),
            replay_label: appHelper.getLocaleString("replay_label"),
            pause_label: appHelper.getLocaleString("pause_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            hideContinueAfterPressed: appHelper.isDefined(props.hideContinueAfterPressed) ? props.hideContinueAfterPressed : false,
            continuePressed: false,

        };

        this.handleProgression = this.handleProgression.bind(this);
        this.show = this.show.bind(this);
        this.onStartFunc = this.onStartFunc.bind(this);
        this.onEndedFunc = this.onEndedFunc.bind(this);
        this.onPauseFunc = this.onPauseFunc.bind(this);
        this.onPlayFunc = this.onPlayFunc.bind(this);
        this.setClass = this.setClass.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.getVideoPath = this.getVideoPath.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getControlClass = this.getControlClass.bind(this);
        this.reInit = this.reInit.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.onComplete = this.onComplete.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {

        this.getObjectStatus();
        this.show();
    }

    componentWillReceiveProps(nextProps) {

        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData)
            });
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                play_label: appHelper.getLocaleString("play_label"),
                replay_label: appHelper.getLocaleString("replay_label"),
                pause_label: appHelper.getLocaleString("pause_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
            });
        }
    }

    componentDidUpdate() {

    }

    reInit() {

        this.getObjectStatus();
        this.onPlayFunc();
// this.show();
    }

    getObjectStatus() {
        let objectUserData = {};
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            let subScreenParent = this.props.callbacks.getSubScreenParent();
            let screen_id = this.props.callbacks.getScreenId();
            if (appHelper.isDefined(subScreenParent)) {
                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
            } else if (this.state.isResourceObject) {
                objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
            } else {
                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
            }
        }

        if (!this.state.screenObject.required_for_completion || objectUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({status: objectConstants.STATUS_COMPLETE});
            this.handleProgression();
        }

    }

    getVideoPath(video) {
        if (video.sub_type == objectConstants.VIDEO_SUB_TYPE_MP4 && appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(video.src) && video.src.length > 0) {
                return require(`../../../../moveToDist/${video.src}`);
            }
        } else {
            return video.src;
        }
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: false
        };

        this.props.callbacks.onObjectComplete(completionData);
        //t

    }

    //<iframe src={`https://player.vimeo.com/video/${this.state.locale.vimeo_id}`} width="100%" height="auto"  allowFullScreen />

    onStartFunc(event) {
        this.setState({isPlaying: true});
        this.setState({status: objectConstants.STATUS_IN_PROGRESS});
        this.props.callbacks.scrollToVideo();
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoOpened(this.state.screenObject.asset_id, this.state.locale.label);
        }
    }

    onEndedFunc(event) {

        this.handleProgression();
        this.setState({isPlaying: false});
        this.setState({status: objectConstants.STATUS_COMPLETE});
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoPlayed(this.state.screenObject.asset_id, this.state.locale.label);
        }

    }

    onPauseFunc(event) {
        this.setState({isPlaying: false});
    }

    onPlayFunc(event) {
        this.setState({isPlaying: true});
        this.props.callbacks.scrollToVideo();
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            this.setState({status: objectConstants.STATUS_IN_PROGRESS});
        }
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoOpened(this.state.screenObject.asset_id, this.state.locale.label);
        }
    }

    setClass() {
        if (this.state.isPlaying) {
            return "playing";
        } else {
            return "";
        }
    }

    setStatusClass() {

        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "viewed";
        } else {
            return "not-viewed";
        }
    }

    show() {
        let objectRef = this.objectRef.current;
        if (appHelper.isEleDefined(objectRef)) {
            let params = {
                ele: objectRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: null
            };
            animationHelper.fadeIn(params);
        }
    }

    getControlClass() {
        return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setKeyboardAccessibility(event) {
        if (appHelper.isDefined(event)) {
            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
                event.preventDefault();
                this.onPlayFunc();
            }
        }
    }

    onComplete(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({continuePressed: true});
        let hasNextObject = this.props.callbacks.hasNextObject(this.state.screenObject);
        if (hasNextObject) {
            let nextObject = this.props.callbacks.getNextScreenObject(this.state.screenObject);
            this.props.callbacks.getObject(nextObject);
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }

    render() {
        return (

            <div className="object-container" ref={this.objectRef}>
                <div className={`video-object`}>

                    <div className="video-wrapper">
                        <ReactPlayer id={`video_${this.state.screenObject.asset_id}`}
                                     ref={`video_${this.state.screenObject.asset_id}`}
                                     url={`${this.getVideoPath(this.state.video)}`}
                                     onStart={this.onStartFunc}
                                     onPause={this.onPauseFunc}
                                     onPlay={this.onPlayFunc}
                                     onEnded={this.onEndedFunc}
                                     width="100%"
                                     height="auto"
                                     playing={this.state.isPlaying}
                                     controls={SHOW_CONTROLS}

                        />
                    </div>
                    <div className="video-details">
                        <div className="video-title-panel">
                            <div>
                                {
                                    this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0
                                        ?
                                        <h4 className={`heading-4 ${this.setStatusClass()}`}
                                            dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                        :
                                        null
                                }


                            </div>
                            <div>
                                {
                                    this.state.status === objectConstants.STATUS_COMPLETE && (!this.state.hideContinueAfterPressed || (this.state.hideContinueAfterPressed && !this.state.continuePressed)) ?
                                        <button className={`btn guroo-btn`}
                                                onClick={this.onComplete}>{this.state.continue_label}</button>
                                        :
                                        null

                                }
                            </div>


                        </div>

                        {
                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                ?

                                <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>

                                :
                                null
                        }
                    </div>
                </div>
            </div>

        );
    }
}

/* config={{ file: {
                                         tracks: [
                                             {kind: 'subtitles', src:  require(`../../../../moveToDist/${this.state.video.captions}`), srcLang: 'en', default: true}
                                         ]
                                     }}}*/
ReactVideoInline.propTypes = {
    screenObject: PropTypes.object.isRequired,
    video: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    autoPlay: PropTypes.bool.isRequired,
    lang: PropTypes.string.isRequired,
    hideContinueAfterPressed: PropTypes.bool,
    actions: PropTypes.object.isRequired
};

ReactVideoInline.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReactVideoInline);



/** WEBPACK FOOTER **
 ** ./src/components/objects/video/VideoPlayer.js
 **/